import { Injectable } from '@angular/core';
import axios from 'src/app/Service/axios';
import { parseResponse } from '../../report.utils';
import { GeofenceApiStatus, GeofenceArea, GeofenceReportRow, ReportCredentials } from './geofence-report.models';

@Injectable({ providedIn: 'root' })
export class GeofenceReportApiService {
  async loadAreas(credentials: ReportCredentials): Promise<GeofenceArea[] | GeofenceApiStatus> {
    return this.post<GeofenceArea[]>('Radyab_GeoFence', credentials);
  }

  async loadRows(endpoint: string, payload: Record<string, unknown>): Promise<GeofenceReportRow[] | GeofenceApiStatus> {
    return this.post<GeofenceReportRow[]>(endpoint, payload);
  }

  async deleteInspection(payload: Record<string, unknown>): Promise<GeofenceApiStatus> {
    return this.post<GeofenceApiStatus>('Radyab_GeoFence_InspectionReport_Delete', payload);
  }

  async loadInspectionZones(payload: Record<string, unknown>): Promise<string | GeofenceApiStatus> {
    const response = await axios.post('Radyab_InspectionGeoFence ', payload);
    const parsed = parseResponse<GeofenceApiStatus>(response.data);
    if (parsed && !Array.isArray(parsed) && (parsed.ISessionExpired || parsed.ISSessionExpired || parsed.iResult === 0)) return parsed;
    return typeof response.data === 'string' ? response.data : JSON.stringify(response.data);
  }

  private async post<T>(endpoint: string, payload: Record<string, unknown> | ReportCredentials): Promise<T | GeofenceApiStatus> {
    const response = await axios.post(endpoint, payload);
    const parsed = parseResponse<T | GeofenceApiStatus>(response.data);
    if (parsed == null) {
      if (typeof response.data === 'string' && response.data.trim()) throw new Error('Invalid report response');
      return [] as unknown as T;
    }
    if (!Array.isArray(parsed) && typeof parsed === 'object') {
      const status = parsed as GeofenceApiStatus;
      if (status.ISessionExpired || status.ISSessionExpired || status.iResult === 0) return status;
    }
    return parsed;
  }
}
